import { cls } from "@wss/cls";
import React from "react";
import Icon from "~/common/Icons/Standard/index";

interface MediaReviewThumbnailVideoOverlayProps {
  showRemainingOverlayMobile?: boolean;
  showRemainingOverlayTablet?: boolean;
  showRemainingOverlayDesktop?: boolean;
  iconClassName?: string;
  filterByRatingEnabled?: boolean;
}
const MediaReviewThumbnailVideoOverlay = ({
  showRemainingOverlayMobile = false,
  showRemainingOverlayTablet = false,
  showRemainingOverlayDesktop = false,
  iconClassName,
  filterByRatingEnabled = false,
}: MediaReviewThumbnailVideoOverlayProps) => {
  return (
    <div
      className={cls(
        filterByRatingEnabled &&
          showRemainingOverlayMobile &&
          "hidden xs:block",
        filterByRatingEnabled &&
          showRemainingOverlayTablet &&
          "hidden lt:block",
        showRemainingOverlayDesktop && "hidden",
      )}
    >
      <div className="absolute z-20 w-full h-full bg-gray-800/70 mix-blend-multiply" />
      <div className="isolate absolute z-30 w-full h-full flex justify-center items-center">
        <Icon
          className={iconClassName}
          height="2rem"
          width="2rem"
          name="play"
        />
      </div>
    </div>
  );
};

export default MediaReviewThumbnailVideoOverlay;
